import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

var swiper = new Swiper(".banner-swiper .mySwiper", {
  spaceBetween: 10,
  slidesPerView: 3,
  watchSlidesProgress: true,
  direction: 'horizontal',
  breakpoints: { 
    768: {  //当屏幕宽度大于等于768 
      spaceBetween: 20,
      slidesPerView: 3,
      direction: 'vertical',
    },
    1280: {  //当屏幕宽度大于等于1280
      spaceBetween: 30,
      slidesPerView: 3,
      direction: 'vertical',
    }
  }
});
var swiper2 = new Swiper(".banner-swiper .mySwiper2", {
  spaceBetween: 10,
  thumbs: {
    swiper: swiper,
  },
});
